<template>
  <div>
    <div class="topFrom" ref="sub">
      <el-form inline label-width="90px">
        <el-row :gutter="10">
          <el-col :span="12" style="{'display':'block' }">
            <el-form-item prop="accountType" :label="this.$t('credit.search.partnerType')">
              <el-select
                style="width: 100%"
                v-model="partnerType"
                label=""
                placeholder=""
                clearable
                filterable
              >
                <el-option
                  v-for="item in partnerTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="gird">
      <vxe-toolbar size="mini">
        <template v-slot:buttons>
          <div style="padding-bottom: 10px">
            <vxe-button
              size="medium"
              type="primary"
              :loading="load"
              class="vxe-btn-save"
              @click="addRow"
            >
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="icon-add"
              />
              {{ $t('credit.btnList.add') }}
            </vxe-button>
            <vxe-button
              size="medium"
              type="primary"
              :loading="load"
              class="vxe-btn-delete"
              @click="removeSelected()"
            >
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="icon-white-delete"
              />
              {{ $t('credit.btnList.del') }}
            </vxe-button>
            <vxe-button
              size="medium"
              type="primary"
              :loading="load"
              class="vxe-btn-save"
              @click="save()"
            >
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="icon-preserve"
              />
              {{ $t('credit.btnList.save') }}
            </vxe-button>
          </div>
        </template>
      </vxe-toolbar>
      <vxe-grid
        border
        show-overflow
        resizable
        ref="xGrid"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :edit-rules="editRules"
        :data="tableData"
        :edit-config="{ trigger: 'click', mode: 'row' }"
        @cell-click="rowClick"
        :checkbox-config="{ labelField: 'name', checkMethod }"
      >
        >
        <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
        <vxe-table-column
          type="index"
          width="60"
          :title="$t('table.index')"
          fixed="left"
        ></vxe-table-column>
        <vxe-table-column
          field="creditRequestNo"
          width="120"
          :title="$t('credit.table.creditRequestNo')"
          :edit-render="{ name: 'searchModal' }"
        >
          <template v-slot:edit="{ row }">
            <SearchModal
              width="800"
              ref="searchModal"
              propName="creditRequestNo"
              propCode="creditRequestNo"
              className="customer-search"
              model="creditRequestNo"
              :placeholder="$t('credit.table.creditRequestNoPlaceholder')"
              :API="creditRequest.API"
              :page="creditRequest.page"
              :query="creditRequest.query"
              :columnList="creditRequest.columnList"
              :currentValue="row.creditRequestNo"
              :searchColumns="creditRequest.searchColumns"
              :isMultiple="true"
              @setSearchModal="setCreditRequestNo"
              :extraData="{ requestStatus: 'ZT03' }"
            ></SearchModal>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="controlAreaName"
          width="170"
          :title="$t('credit.table.businessDepartmentName')"
          :edit-render="{ name: 'ElSelect' }"
        >
          <template v-slot:edit="{ row }">
            <treeselect
              :options="businessDepartmentList"
              :defaultExpandLevel="Infinity"
              openDirection="auto"
              :clearable="false"
              :maxHeight="200"
              :zIndex="2999"
              :flat="true"
              :append-to-body="true"
              v-model="row.controlAreaCode"
              :currentValue="row.controlAreaCode"
              @select="(val) => selectNode(val)"
              :placeholder="$t('company.treeselect.searchIndex')"
              :searchPromptText="$t('company.treeselect.searchIndex')"
              :normalizer="normalizer"
              :noResultsText="$t('company.treeselect.noData')"
            />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="partnerType"
          width="120"
          :title="$t('credit.table.partnerTypeName')"
          :edit-render="{
            name: 'ElSelect',
            defaultValue: partnerType,
            options: partnerTypeList,
            props: { disabled: true },
          }"
        ></vxe-table-column>
        <vxe-table-column
          field="partnerCode"
          width="120"
          :title="$t('credit.table.partnerCode')"
          :edit-render="{ name: 'searchModal' }"
        >
          <template v-slot:edit="{ row }">
            <SearchModal
              ref="searchModal"
              propName="partnerCode"
              propCode="partnerCode"
              className="customer-search"
              model="partnerCode"
              :placeholder="$t('credit.table.partnerCodePlaceholder')"
              :API="partner.API"
              :query="partner.query"
              :page="partner.page"
              :searchColumns="partner.searchColumns"
              :columnList="partner.columnList"
              :isMultiple="true"
              :currentValue="row.partnerCode"
              @setSearchModal="setPartner"
              :disabled="true"
            ></SearchModal>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="partnerName"
          width="120"
          :title="$t('credit.table.partnerName')"
          :edit-render="{ name: 'searchModal' }"
        >
          <template v-slot:edit="{ row }">
            <search-table
              v-model="row.partnerName"
              searchType="partner"
              :isMultiple="true"
              :currentValue="row.partnerName || null"
              :checkRowKeys="[row.partnerCode]"
              @input="setPartner"
              :extraData="{
                partnerTypes: `${row.partnerType},HZHB03`,
              }"
            ></search-table>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="accountType"
          width="120"
          :title="$t('credit.table.accountType')"
          :edit-render="{ name: 'ElSelect', defaultValue: 'ZK01', options: accountTypeList }"
        ></vxe-table-column>
        <vxe-table-column
          field="creditType"
          width="120"
          :title="$t('credit.table.creditType')"
          :edit-render="{ name: 'ElSelect', defaultValue: 'SX01', options: creditTypeList }"
        ></vxe-table-column>
        <vxe-table-column
          field="creditCode"
          width="140"
          :title="$t('credit.table.creditCode')"
          :edit-render="{ name: 'ElInput', props: { clearable: true } }"
        >
          <template v-slot:edit="{ row }">
            <el-input
              v-model="row.creditCode"
              :placeholder="$t('credit.table.creditCodePlaceholder')"
              clearable
              :maxlength="'20'"
            >
            </el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="creditCodeDesc"
          width="120"
          :title="$t('credit.table.creditCodeDesc')"
          :edit-render="{ name: 'ElInput' }"
        >
          <template v-slot:edit="{ row }">
            <el-input v-model="row.creditCodeDesc" clearable maxlength="20"> </el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="validDate"
          width="170"
          :title="$t('credit.table.validDate')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-date-picker
              v-model="row.validDate"
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerStartOptions"
              @focus="setActiveIndex(rowIndex)"
              clearable
            ></el-date-picker> </template
        ></vxe-table-column>
        <vxe-table-column
          field="invalidDate"
          width="170"
          :title="$t('credit.table.invalidDate')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="{ row, rowIndex }">
            <el-date-picker
              v-model="row.invalidDate"
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerEndOptions"
              @focus="setActiveIndex(rowIndex)"
              clearable
            ></el-date-picker>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="requestAmount"
          width="140"
          :title="$t('credit.table.requestAmount')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <input-number
              v-model="row.requestAmount"
              :controls="false"
              max="99999999999.99"
              :precision="6"
              :placeholder="$t('credit.table.requestAmountPlaceholder')"
              clearable
              maxlength="32"
            >
            </input-number>
          </template>
          <template v-slot="scope">
            {{ Number(scope.row.requestAmount).toFixed(2) }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="currencyTypeName"
          width="120"
          :title="$t('credit.table.currencyType')"
          :edit-render="{ name: 'input' }"
        >
          <template v-slot:edit="{ row }">
            <!-- <el-select v-model="row.currencyTypeName" @change="selectCurrency"
                :placeholder='$t("credit.table.partnerCodePlaceholder")'>
                <el-option
                    v-for="item in currencyTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
            </el-select> -->
            <el-input v-model="row.currencyTypeName" :disabled="true" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="chargePersonAuthority"
          width="120"
          title="部门责任人权限"
          :edit-render="{ name: 'ElSelect', options: chargePersonAuthorityList }"
        ></vxe-table-column>
        <vxe-table-column
          field="creditPeriod"
          width="120"
          title="账期"
          :edit-render="{ name: 'ElInput' }"
        >
          <template v-slot:edit="{ row }">
            <el-input v-model="row.creditPeriod" clearable maxlength="256"> </el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="mark"
          width="120"
          :title="$t('credit.table.mark')"
          :edit-render="{ name: 'ElInput' }"
        >
          <template v-slot:edit="{ row }">
            <el-input v-model="row.mark" clearable maxlength="256"> </el-input>
          </template>
        </vxe-table-column>
      </vxe-grid>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import SearchModal from '@/components/SearchModal';
  import SearchTable from '@/components/form-item/search-table';
  import API from '@/api/purchaseSalesCenter/credit/credit.js';
  import COOPERATION_API from '@/api/masterData/cooperation';
  import DataBaseAPI from '@/api/dataBase';
  import CONTROL_API from '@/api/masterData/company.js';
  // import ajaxSelect from '@/pages/wareHouse/stockManage/components/ajax-select';
  import InputNumber from '@/components/form-item/input-number.vue';
  import XEUtils from 'xe-utils';
  export default {
    name: 'creditAdd',
    components: {
      SearchModal,
      SearchTable,
      // ajaxSelect,
      InputNumber,
    },
    data() {
      return {
        load: false,
        rowIndex: 0,
        tableData: [],
        partnerType: 'HZHB01',
        partnerTypeList: [], //合作伙伴类型
        businessDepartmentList: [], //事业部门列表
        currencyTypeList: [], //币种
        originCurrencyType: [], //币种原始信息
        apiData: { isEnabled: 1 },
        creditTypeList: [], //授信类型
        chargePersonAuthorityList: [], //部门责任人权限
        accountTypeList: [], //账款类型
        currencyUrl: API.LIST_CURRENCY,
        tableToolbar: {
          id: 'toolbar',
          // refresh: true,
          // setting: {
          //   storage: true
          // }
        },
        activeIndex: '',
        defaultCurrencyName: '', //默认币种
        pickerStartOptions: {
          disabledDate: (time) => {
            if (this.tableData[this.activeIndex] && this.tableData[this.activeIndex].invalidDate) {
              return (
                time.getTime() >= new Date(this.tableData[this.activeIndex].invalidDate).getTime()
              );
            }
          },
        },
        pickerEndOptions: {
          disabledDate: (time) => {
            if (this.tableData[this.activeIndex] && this.tableData[this.activeIndex].validDate) {
              return (
                time.getTime() <=
                new Date(this.tableData[this.activeIndex].validDate).getTime() - 3600 * 24 * 1000
              );
            }
          },
        },
        normalizer(node) {
          //只能选择根节点
          if (node.children) {
            node.children.map((item) => {
              item['isDisabled'] = true;
            });
          }
          return node;
        },
        rowData: {
          partnerType: this.partnerType,
          accountType: '',
          creditType: '',
          controlAreaCode: null,
          controlAreaName: null,
          currencyTypeCode: 'RMB',
          currencyTypeName: 'RMB',
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      //合作伙伴
      partner() {
        return {
          API: COOPERATION_API.LIST_PARTNEREXTEND, // 合作伙伴：供应商类型
          propName: 'partnerZhName', // 输入框展示内容
          propCode: 'partnerCode',
          query: {},
          searchColumns: [
            {
              name: window.vm.$t('cooperation.label.partnerZhName'),
              prop: 'partnerZhName',
              type: 'input',
            },
          ],
          columnList: [
            { prop: 'partnerZhName', label: window.vm.$t('cooperation.label.partnerZhName') },
            { prop: 'partnerCode', label: window.vm.$t('cooperation.label.partnerCode') },
            { prop: 'identityNo', label: window.vm.$t('cooperation.label.identityNo') },
            { prop: 'creditCode', label: window.vm.$t('cooperation.label.creditCode') },
            { prop: 'requestByName', label: window.vm.$t('cooperation.label.requestByName') },
            { prop: 'requestTime', label: window.vm.$t('cooperation.label.requestTime') },
            // { prop: "requestStatus", label: window.vm.$t('cooperation.label.requestStatus') },
          ],
        };
      },
      editRules() {
        return {
          // creditRequestNo: [
          //   { required: true, message: this.$t("credit.table.creditRequestNoPlaceholder"), trigger: ["blur", "change"] }
          // ],
          controlAreaName: [
            {
              required: true,
              message: this.$t('credit.table.businessDepartmentNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          partnerType: [
            {
              required: true,
              message: this.$t('credit.table.partnerTypeNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          partnerCode: [
            {
              required: true,
              message: this.$t('credit.table.partnerCodePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          partnerName: [
            {
              required: true,
              message: this.$t('credit.table.partnerNamePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          accountType: [
            {
              required: true,
              message: this.$t('credit.table.accountTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          creditType: [
            {
              required: true,
              message: this.$t('credit.table.creditTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          creditCode: [
            {
              required: true,
              message: this.$t('credit.table.creditCodePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          creditCodeDesc: [
            {
              required: true,
              message: this.$t('credit.table.creditCodeDescPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          validDate: [
            {
              required: true,
              message: this.$t('credit.table.validDatePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          invalidDate: [
            {
              required: true,
              message: this.$t('credit.table.invalidDatePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          requestAmount: [
            {
              required: true,
              message: this.$t('credit.table.requestAmountPlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          currencyTypeName: [
            {
              required: true,
              message: this.$t('credit.table.currencyTypePlaceholder'),
              trigger: ['blur', 'change'],
            },
          ],
          chargePersonAuthority: [
            { required: true, message: '部门责任人权限不能为空', trigger: ['blur', 'change'] },
          ],
          creditPeriod: [{ required: true, message: '账期不能为空', trigger: ['blur', 'change'] }],
        };
      },
      creditRequest() {
        return {
          API: API.APPLICATION_CREDIT_LIST_API,
          query: {
            userCompany: null,
            partnerName: null,
            enterpriseType: null,
            requestDateStart: null,
            requestDateEnd: null,
            creditType: null,
            accountType: null,
          },
          //搜索字段
          searchColumns: [
            {
              prop: 'controlAreaCode',
              name: this.$t('applicationCredit.search.businessDepartment'),
              placeholder: this.$t('applicationCredit.search.businessDepartmentPlaceholder'),
              type: 'treeSelect',
              apiUrl: DataBaseAPI.LIST_TREE,
              apiData: {
                tenantCode: this.userInfo.userInfo.tenantCode,
                adminFlag: this.userInfo.userInfo.adminFlag,
              },
              clearable: false,
              normalizerFlag: false,
            },
            {
              prop: 'partnerName',
              name: this.$t('applicationCredit.search.partnerName'),
              type: 'input',
              placeholder: this.$t('applicationCredit.search.partnerNamePlaceholder'),
            },
            {
              prop: 'enterpriseType',
              name: this.$t('applicationCredit.search.enterpriseProperty'),
              type: 'select',
              clearabled: true,
              placeholder: this.$t('applicationCredit.search.enterprisePropertyPlaceholder'),
              options: this.enterprisePropertyList,
            },
            {
              prop: 'requestDateStart',
              name: this.$t('applicationCredit.search.requestDateStart'),
              type: 'startDaterangePicker',
              placeholder: this.$t('applicationCredit.search.requestDateStartPlaceholder'),
            },
            {
              prop: 'requestDateEnd',
              name: this.$t('applicationCredit.search.requestDateEnd'),
              type: 'endDaterangePicker',
              placeholder: this.$t('applicationCredit.search.requestDateEndPlaceholder'),
            },
            {
              prop: 'creditType',
              name: this.$t('applicationCredit.search.creditType'),
              type: 'select',
              clearabled: true,
              placeholder: this.$t('applicationCredit.search.creditTypePlaceholder'),
              options: this.creditTypeList,
            },
            {
              prop: 'accountType',
              name: this.$t('applicationCredit.search.accountsType'),
              type: 'select',
              clearabled: true,
              placeholder: this.$t('applicationCredit.search.accountsTypePlaceholder'),
              options: this.accountTypeList,
            },
          ],
          columnList: [
            {
              prop: 'creditRequestNo',
              label: this.$t('applicationCredit.table.creditRequestNo'),
              width: 120,
            },
            {
              prop: 'partnerName',
              label: this.$t('applicationCredit.table.partnerName'),
              width: 120,
            },
            {
              prop: 'accountTypeName',
              label: this.$t('applicationCredit.table.accountType'),
              width: 120,
            },
            {
              prop: 'creditTypeName',
              label: this.$t('applicationCredit.table.creditType'),
              width: 120,
            },
            {
              prop: 'requestAmount',
              label: this.$t('applicationCredit.table.requestAmountTable'),
              width: 120,
            },
            { prop: 'validDate', label: this.$t('applicationCredit.table.validDate'), width: 120 },
            {
              prop: 'invalidDate',
              label: this.$t('applicationCredit.table.invalidDate'),
              width: 120,
            },
            {
              prop: 'createPersonName',
              label: this.$t('applicationCredit.table.createPersonName'),
              width: 120,
            },
            {
              prop: 'lastYearFinanceMark',
              label: this.$t('applicationCredit.table.lastYearFinanceMark'),
              width: 120,
            },
          ],
        };
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getCurrencyList();
      this.getDic();
      this.initDepartment();
    },
    methods: {
      //日期
      setActiveIndex(index) {
        this.activeIndex = index;
      },
      //币种
      async getCurrencyList() {
        const selectStatus = await this.$axios.get(API.LIST_CURRENCY);
        if (
          selectStatus.data.code == 0 &&
          selectStatus.data.data &&
          selectStatus.data.data.length > 0
        ) {
          this.originCurrencyType = selectStatus.data.data;
          selectStatus.data.data.map((item) => {
            if (item.currencyCode == 'CNY') {
              this.defaultCurrencyName = item.currencyName;
            }
            let obj = {
              value: item.currencyCode,
              label: item.currencyName + '  ' + item.currencyCode,
            };
            this.currencyTypeList.push(obj);
          });
        }
        this.getData();
      },
      //事业部门
      initDepartment() {
        const params = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          adminFlag: this.userInfo.userInfo.adminFlag,
          treeFlag: 1,
          currentStatus: '0',
        };
        this.$axios.post(CONTROL_API.GET_CONTROL_LIST_API, params).then((res) => {
          if (0 == res.data.code && res.data.data && res.data.data.length > 0) {
            this.businessDepartmentList = res.data.data;
            this.getSelectedNode(this.businessDepartmentList, this.businessDepartmentList);
          }
        });
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.partnerTypeList = res.data.data;
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
              //  for (var item of res.data.data) {
              //   this.creditTypeData[item["value"]] = item["label"]
              // }
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'yes-no', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.chargePersonAuthorityList = res.data.data;
              //  for (var item of res.data.data) {
              //   this.creditTypeData[item["value"]] = item["label"]
              // }
            }
          });
        //账款类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'account_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.accountTypeList = res.data.data;
            }
          });
        //企业类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'enterprise_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.enterprisePropertyList = res.data.data;
            }
          });
        //申请单状态
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'request_status', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.requestStatusList = res.data.data;
              // for (var item of res.data.data) {
              //   this.requestStatusData[item["value"]] = item["label"]
              // }
            }
          });
      },
      //设置申请单号
      setCreditRequestNo(name, value) {
        if (value) {
          this.tableData[this.rowIndex].creditRequestNo = value[0].creditRequestNo;
          this.tableData[this.rowIndex].controlAreaName = value[0].controlAreaName || null;
          this.tableData[this.rowIndex].controlAreaCode = value[0].controlAreaCode || null;
          this.tableData[this.rowIndex].partnerCode = value[0].partnerNo;
          this.tableData[this.rowIndex].partnerName = value[0].partnerName;
          this.tableData[this.rowIndex].partnerType =
            value[0].partnerType || this.tableData[this.rowIndex].partnerType;
          this.tableData[this.rowIndex].accountType = value[0].accountType;
          this.tableData[this.rowIndex].creditType = value[0].creditType;
          this.tableData[this.rowIndex].validDate = value[0].validDate;
          this.tableData[this.rowIndex].invalidDate = value[0].invalidDate;
          this.tableData[this.rowIndex].requestAmount = value[0].requestAmount;
          this.$refs.xGrid.updateData();
        } else {
          this.tableData[this.rowIndex].creditRequestNo = '';
          this.tableData[this.rowIndex].controlAreaName = null;
          this.tableData[this.rowIndex].controlAreaCode = null;
          this.tableData[this.rowIndex].partnerCode = '';
          this.tableData[this.rowIndex].partnerName = '';
          this.tableData[this.rowIndex].partnerType = '';
          this.tableData[this.rowIndex].accountType = '';
          this.tableData[this.rowIndex].creditType = '';
          this.tableData[this.rowIndex].validDate = '';
          this.tableData[this.rowIndex].invalidDate = '';
          this.tableData[this.rowIndex].requestAmount = '';
        }
      },
      //选择合作伙伴
      setPartner(value) {
        if (value.length > 0) {
          this.tableData[this.rowIndex].partnerCode = value[0].partnerCode;
          this.tableData[this.rowIndex].partnerName = value[0].partnerZhName;
          // this.tableData[this.rowIndex].partnerType = value[0].partnerType
          this.$refs.xGrid.updateData();
        } else {
          this.tableData[this.rowIndex].partnerCode = '';
          this.tableData[this.rowIndex].partnerName = '';
          // this.tableData[this.rowIndex].partnerType = value[0].partnerType
          this.$refs.xGrid.updateData();
        }
      },
      //选择事业部门
      selectNode(value) {
        this.tableData[this.rowIndex].controlAreaCode = value.id;
        this.tableData[this.rowIndex].controlAreaName = value.label;
      },
      //选择币种
      selectCurrency(val) {
        this.originCurrencyType.map((item) => {
          if (item.currencyCode == val) {
            this.tableData[this.rowIndex].currencyTypeCode = item.currencyCode;
            this.tableData[this.rowIndex].currencyTypeName = item.currencyName;
          }
        });
      },
      //点击表格记录正在编辑哪一行
      rowClick(value) {
        this.rowIndex = value.$rowIndex;
      },
      getData() {
        if (this.$route.query && this.$route.query.id) {
          if (typeof this.$route.query.id == 'string') {
            this.$route.query.id = this.$route.query.id.split(',');
          }
          //如果是修改页面，先查询需要修改数据的详情
          this.$axios
            .post(API.DETAIL_APPLICATION_API, { ids: this.$route.query.id })
            .then((res) => {
              if (0 == res.data.code) {
                this.tableData = res.data.data;
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
        } else {
          this.tableData = [];
          for (let i = 0; i < 1; i++) {
            let obj = {
              validDate: '',
              invalidDate: '',
              requestAmount: null,
              partnerType: this.partnerType,
              accountType: '',
              creditType: '',
              controlAreaCode: null,
              controlAreaName: null,
              currencyTypeCode: 'CNY',
              currencyTypeName: this.defaultCurrencyName,
              chargePersonAuthority: '0',
            };
            this.tableData.push(obj);
          }
        }
      },
      //新增行
      addRow() {
        let obj = {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          partnerType: this.partnerType,
          accountType: '',
          creditType: '',
          controlAreaCode: null,
          controlAreaName: null,
          currencyTypeCode: 'CNY',
          currencyTypeName: this.defaultCurrencyName,
          validDate: '',
          invalidDate: '',
          requestAmount: null,
          creditCode: '',
          chargePersonAuthority: '0',
        };
        this.tableData.push(obj);
      },
      checkMethod({ row }) {
        if (row.id) {
          return false;
        }
        return true;
      },
      //删除选中行
      removeSelected() {
        let data = this.$refs.xGrid.getSelectRecords();
        if (data && data.length > 0) {
          this.load = true;
          this.$confirmAction()
            .then(() => {
              this.$refs.xGrid.removeSelecteds();
              this.tableData = this.$refs.xGrid.getTableData().fullData;
              this.load = false;
            })
            .catch(() => {
              this.load = false;
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('applicationCredit.msg.delSelectedModify'),
            type: 'error',
          });
        }
      },
      //保存
      save() {
        // let addData = this.$refs.xGrid.getInsertRecords();
        // let editData = this.$refs.xGrid.getUpdateRecords();
        this.$refs.xGrid.validate((valid) => {
          if (valid) {
            //let data = addData.concat(editData)
            const { tenantCode, companyCode, companyName, departmentCode, departmentName } =
              this.userInfo.userInfo;
            const obj = { tenantCode, companyCode, companyName, departmentCode, departmentName };
            let params = {
              list: JSON.stringify(
                this.tableData.map((item) => {
                  return (item = Object.assign(item, obj, {
                    availableAmount: item.requestAmount,
                  }));
                })
              ),
            };
            // let flag = this.valid(this.tableData)
            let flag = this.validData(params);

            if (flag) {
              this.load = true;
              // data.map(item=>{
              //   delete item._XID
              // })
              this.$axios.post(API.ADD_APPLICATION_API, params).then((res) => {
                if (0 == res.data.code) {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                  });
                  this.gotoList(this.$route.name);
                } else {
                  this.load = false;
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
            }
          } else {
            this.load = false;
          }
        });
      },
      //跳转到列表页面
      gotoList(name) {
        let path = {
          fromPath: {
            path: `/credit/${name}`,
            name: name,
            meta: {
              keepAlive: true,
              title: '',
            },
          },
          toPath: {
            path: '/credit/creditList',
            name: 'creditList',
            meta: {
              keepAlive: false,
              title: this.$t('applicationCredit.msg.listCreditRequests'),
            },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //重叠验证
      validData(data) {
        data = XEUtils.toArray(data);
        console.log(typeof data);
        let recordsList = [];
        let flag = true;
        //按照事业部门、合作伙伴类型、合作伙伴编码、授信类型==长期 进行分类整合
        data.map((item) => {
          //判断开始时间是否小于结束时间
          if (item.validDate > item.invalidDate) {
            this.$message({
              type: 'info',
              message: this.$t('credit.msg.validDate'),
            });
            flag = false;
          }
          if (item.creditType === 'SX01') {
            let recordId =
              item.businessDepartment + '-' + item.partnerType + '-' + item.partnerCode;
            if (!recordsList[recordId]) {
              recordsList.push({
                recordId: recordId,
                data: [item],
              });
            } else {
              recordsList.map((list) => {
                if (list.recordId === item.recordId) {
                  list.data.push(item);
                }
              });
            }
          }
        });
        //循环recordsList，查询data中的数据是否有时间上的重复
        recordsList.forEach((item) => {
          let startTimeArr = [];
          let endTimeArr = [];
          // let timeE = '';
          // let timeS = '';
          item.data.map((child) => {
            if (child.validDate > child.invalidDate) {
              return false;
            }
            startTimeArr.push(child.validDate);
            endTimeArr.push(child.invalidDate);
          });
          startTimeArr.sort((a, b) => {
            return a > b ? 1 : -1;
          });
          endTimeArr.sort((a, b) => {
            return a > b ? 1 : -1;
          });
          for (var k = 1; k < startTimeArr.length; k++) {
            if (startTimeArr[k] <= endTimeArr[k - 1]) {
              this.$message({
                type: 'info',
                message: this.$t('credit.msg.overlayDate'),
              });
              flag = false;
            }
          }
        });
        // recordsList.map(item=>{
        //   let startTimeArr = [];
        //   let endTimeArr = [];
        //   let timeE = '',timeS = '';
        //   item.data.map(child=>{
        //     if(child.validDate>child.invalidDate){
        //       return false
        //     }
        //     startTimeArr.push(child.validDate);
        //     endTimeArr.push(child.invalidDate);
        //   })
        //   startTimeArr.sort((a,b) => {
        //       return a > b ? 1 : -1;
        //   });
        //   endTimeArr.sort((a,b) => {
        //       return a > b ? 1 : -1;
        //   });
        //   for(var k=1;k<startTimeArr.length;k++){
        //       if (startTimeArr[k] <= endTimeArr[k-1]){
        //         this.$message({
        //           type: "info",
        //           message: this.$t("credit.msg.overlayDate")
        //         });
        //           flag = false
        //       }
        //   }
        // })
        return flag;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .topFrom {
    padding: 26px 0 8px 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
  .gird {
    margin-top: 10px;
    padding: 12px 0 20px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 17px 0px rgba(72, 89, 102, 0.16);
    border-radius: 3px;
  }
</style>
